function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { rem } from 'polished';
import React from 'react';
import Box from '../Box';
const ShortenIcon = _ref => {
  let {
    size = 16,
    bg = 'currentColor',
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, _extends({
    as: "svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: rem(size),
    height: rem(size),
    fill: bg,
    verticalAlign: "middle"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12.659 9.753a1 1 0 0 1-1.318 0l-4-3.5a1 1 0 1 1 1.317-1.506L11 6.797V3a1 1 0 1 1 2 0v3.796l2.341-2.049a1 1 0 0 1 1.318 1.506l-4 3.5ZM4 12a1 1 0 0 1 1-1h14a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1Zm8.659 2.247a1 1 0 0 0-1.318 0l-4 3.5a1 1 0 0 0 1.317 1.506L11 17.203V21a1 1 0 1 0 2 0v-3.796l2.341 2.049a1 1 0 0 0 1.318-1.506l-4-3.5Z"
  }));
};
export default ShortenIcon;